import type { MapObject } from '~/common/types';
import Icon from '~/components2/Icon';
import { calculateArea, calculateLength } from '~/helpers/unitHelpers';
import { LineIcon, PolygonIcon } from '../Toolbar/ToolbarIcons';

interface ObjCreationDataProps {
  currentObject: MapObject;
  unitSystem: 'metric' | 'imperial';
}

export default function ObjCreationData({ currentObject, unitSystem }: ObjCreationDataProps) {
  let objectData: { value: number; unit: string } | undefined;

  if (currentObject.type === 'polygon') {
    objectData = calculateArea({
      geometry: currentObject!.geometry,
      unitSystem,
    });
  } else if (currentObject.type === 'line') {
    objectData = calculateLength({
      geometry: currentObject!.geometry,
      unitSystem,
    });
  }

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Icon className="text-brand" icon="user" />
        {currentObject!.updatedBy.name}
      </div>
      <div className="flex items-center gap-3">
        {currentObject?.type === 'polygon' ? (
          <>
            <PolygonIcon className="flex h-8 w-8 items-center justify-center fill-brand-dark" />
            {`${objectData?.value.toLocaleString()} ${objectData?.unit}`}
          </>
        ) : currentObject?.type === 'line' ? (
          <>
            <LineIcon className="h-7 w-7 fill-brand-dark" />
            {`Length: ${objectData?.value.toLocaleString()} ${objectData?.unit}`}
          </>
        ) : null}
      </div>
    </div>
  );
}
